import React from 'react';
import {
  Button,
  Stack,
  useMediaQuery,
  useTheme
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ActionsCard from '../ActionsCard';
import CardTitle from '../common/CardTitle';

interface IdeaActionsPanelProps {
  onBackToIdeas: () => void;
  loading: boolean;
}

const IdeaActionsPanel: React.FC<IdeaActionsPanelProps> = ({
  onBackToIdeas,
  loading
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <ActionsCard
      variant="full"
      titleComponent={
        <CardTitle 
          title="Actions" 
          tooltip="What would you like to do next?"
        />
      }
    >
      <Stack 
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 2, md: 2 }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        sx={{ width: '100%' }}
      >
        <Button 
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={onBackToIdeas}
          disabled={loading}
          sx={{ 
            flex: 1,
            py: { xs: 1.5, sm: 1.2 },
            fontSize: { xs: '1rem', sm: '0.875rem' },
            '&:hover': {
              transform: 'translateY(-1px)',
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          Back to Ideas
        </Button>
      </Stack>
    </ActionsCard>
  );
};

export default IdeaActionsPanel;